import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCalendarAlt, FaMapMarkerAlt, FaUserAlt } from "react-icons/fa";
import { useParams } from "react-router";
import eventApi from "../../api/Eventapi";

const Events_Detail = () => {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    eventApi
      .getBySlug(slug)
      .then((res) => setEvent(res))
      .catch((err) => console.error("Error fetching event:", err));
  }, [slug]);

  if (!event) return <p>Loading...</p>;

  const images = event.eventDetails || [];

  return (
    <div className="event-detail-page">
      {/* Hero Section */}
      <Container fluid className="Main-background" style={{ height: "25rem" }}>
        <div
          className="bg-image"
          style={{
            backgroundImage: `url(${event.featured_image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "400px",
          }}
        />
        <div className="overlay" />

        <Container>
          <Row>
            <Col lg={12} className="page-top-content text-center">
              <h1 className="page-title">{event.title}</h1>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Event Content */}
      <Container className="event-content-section py-5">
        <Row className="justify-content-center">
          {/* Main Content */}
          <Col lg={8} md={10}>
            <div className="event-detail-wrapper">
              <div dangerouslySetInnerHTML={{ __html: event.description }} />

              {/* Image Gallery */}
              <h2 className="mt-5 mb-3">Event Highlights</h2>
              <Row className="g-3">
                {images.length > 0 ? (
                  images.map((detail, id) => (
                    <Col lg={4} md={6} sm={6} xs={12} key={id}>
                      <div className="event-image-wrapper">
                        <img
                          src={detail.imageUrl}
                          alt={`Event Image ${id + 1}`}
                          className="event-image"
                        />
                      </div>
                    </Col>
                  ))
                ) : (
                  <p>No event images available</p>
                )}
              </Row>
            </div>
          </Col>

          {/* Sidebar */}
          <Col lg={4} md={12} className="mt-4 mt-lg-0">
            <div className="event-info-box shadow p-4 rounded">
              <h3 className="mb-3">Event Details</h3>
              <p>
                <FaCalendarAlt /> <strong>Date:</strong>{" "}
                {new Date(event.event_date).toLocaleDateString()}
              </p>
              <p>
                <FaMapMarkerAlt /> <strong>Location:</strong>{" "}
                {event.location || "N/A"}
              </p>
              <p>
                <FaUserAlt /> <strong>Organizer:</strong>{" "}
                {event.organizer || "N/A"}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Events_Detail;
